angular.module('tasks')
  .directive('taskManagement', ["localStorageService", "taskStoresService", "PATH", "tagsService", "personService", "TASK_TYPE_FILTER", "taskManagementService", "$q", "overdueTasksService", function (localStorageService, taskStoresService, PATH, tagsService, personService, TASK_TYPE_FILTER, taskManagementService, $q, overdueTasksService) {
    return {
      restrict: 'E',
      scope: {
        companies: '=',
        taskId: '=?'
      },
      templateUrl: PATH.components + 'taskManagement/main.html',
      link: function ($scope) {
        var userInfo = localStorageService.get('userInfo');
        var currentStore = localStorageService.get('currentStore');
        var NEEDS_REVIEW_STATUS = 3;
        var lists = [
          {
            caption: 'Needs Research',
            status: 0
          },
          {
            caption: 'Needs Processing',
            status: 1
          },
          {
            caption: 'Needs Review',
            status: NEEDS_REVIEW_STATUS
          },
          {
            caption: 'Closed',
            status: 4
          }
        ];
        var allCards = [];
        var defAllCards = [];
        var oldState = {
          tagLength: 0,
          list: []
        };

        $scope.state = 'list';
        $scope.limitForDoneList = $scope.offsetTop = 50;
        $scope.offset = 0;
        $scope.inProcessStatus = 2;
        $scope.doneStatus = 4;
        $scope.isLimit = false;

        $scope.typeFilterOptions = TASK_TYPE_FILTER;
        $scope.cardsTypeFilter = $scope.typeFilterOptions[2];
        var WEIRD_FILTER_OPTIONS = {
          ALL_STORES: 1,
          MY_STORES: 2
        };

        $scope.weirdFilterOptions = [{
          caption: 'View All Stores',
          value: WEIRD_FILTER_OPTIONS.ALL_STORES
        }, {
          caption: 'My Stores',
          value: WEIRD_FILTER_OPTIONS.MY_STORES
        }];
        $scope.cardsWeirdFilter = personService.isSupervisor(userInfo)
        ? $scope.weirdFilterOptions[1]
        : $scope.weirdFilterOptions[0];

        $scope.tags = [];
        $scope.tagsToFilter = [];
        $scope.doneItemsCurrentLength = null;
        $scope.isNotDraggable = function (card) {
          return (
          card.status === NEEDS_REVIEW_STATUS &&
          !personService.isSuperman(userInfo)
        );
        };

        getOverdueTasks();

        $scope.getTagsByQuery = function (query) {
          var tags = tagsService.getTagObjectsByQuery(query, $scope.tagsToFilter, 'text');
          return tags;
        };
        $scope.openCard = function (card) {
          $scope.activeCard = card;
          $scope.state = 'card';
        };
        $scope.closeCard = function () {
          $scope.filter($scope.cardsTypeFilter.value, $scope.cardsWeirdFilter.value, $scope.tags);
          $scope.state = 'list';
        };
        $scope.cardMembersChange = function (cardId, members) {
          var foundCard = _.find(allCards, function (iterationCard) {
            return cardId == iterationCard.id;
          });
          if (foundCard) {
            foundCard.members = members;
          }
        };
        $scope.cardStatusChange = function (card, newStatus, isMove) {
          var foundCard = _.find(allCards, function (iterationCard) {
            return card.id == iterationCard.id;
          });
          if (!foundCard) {
            foundCard = card;
            allCards.push(card);
          }
          foundCard.status = newStatus;
          if (!isMove) $scope.filter($scope.cardsTypeFilter.value, $scope.cardsWeirdFilter.value, $scope.tags);
          return taskManagementService.udpateTask({
            id: card.id,
            status: newStatus
          })
        .then(function (response) {
          var data = response.data;
          $scope.cardMembersChange(card.id, data.members);
          return data;
        });
        };

        $scope.handleCardsWeirdFilterChange = function (type, weirdFilter, tags) {
          $scope.limitForDoneList = 50;
          return $scope.filter(type, weirdFilter, tags);
        };

        $scope.filter = function (type, weirdFilter, tags) {
          getAllCards(tags);
          $scope.doneItemsLength = 0;
          $scope.lists = lists.map(function (list) {
            if (list.status == $scope.doneStatus) sortByProp = 'completionTimeReverse';

            return {
              status: list.status,
              caption: list.caption,
              cards: _.sortBy(_.filter(allCards, function (card) {
                if (card.status !== list.status) {
                  return false;
                }

                if (parseInt(weirdFilter) === WEIRD_FILTER_OPTIONS.MY_STORES) {
                  if (!_.find(card.members, { id: userInfo.id })) {
                    return false;
                  }
                }

                if (list.status == $scope.doneStatus) $scope.doneItemsLength++;

                card.isOverdue = !!_.find($scope.overdueTasks, function (overdueTask) {
                  return overdueTask === card.id;
                });

                var matchesTag = !tags || !tags.length || tagsResult(card, tags[tags.length - 1]) > 0;
                var matchesType = !type || card.type == type;

                return matchesTag && matchesType;
              }), 'name')
            };
          });
          oldState.tagLength = tags && tags.length ? tags.length : 0;
          getDoneItemsLength();
          var numOfDoneCards = $scope.lists[$scope.lists.length - 1].cards.length;
          $scope.limitForDoneList = numOfDoneCards + $scope.offsetTop;
          window.setTimeout(initScrolls, 500);
        };

        $scope.isLoadMoreUnavailable = function (taskList) {
          return $scope.isLimit || taskList.cards.length < $scope.limitForDoneList - $scope.offsetTop;
        };

        $scope.getMoreItems = function ($event, limit) {
          $event.preventDefault();

          if ($scope.limitForDoneList === limit) {
            $scope.offset = 0;
          } else {
            $scope.offset += limit;
          }
          $scope.limitForDoneList += limit;
          taskManagementService.getTasks({
            status: 4,
            limit: $scope.offsetTop,
            offset: $scope.offset
          })
          .then(function (res) {
            if (res.data.length) {
              setCompanyId(res.data);
              $scope.isLimit = false;
              return res.data;
            } else {
              $scope.isLimit = true;
            }
          })
          .then(function (data) {
            if (data && data.length) {
              allCards = updateAllCards(allCards.concat(data));
              var list = getDoneList();
              list.cards = list.cards.concat(data);
              $scope.doneItemsLength = list.cards.length;
            }
          })
          .then(function () {
            // $scope.filter();
            getDoneItemsLength();
          });
        };

        $scope.moveCard = function (card, list, index) {
          var oldCardStatus = card.status;
        // removed card from $scope.lists
          list.cards.splice(index, 1);
        // where card was moved?
          var foundCardIndex = -1;
          var newList = _.find($scope.lists, function (scopeList) {
            foundCardIndex = _.findIndex(scopeList.cards, { id: card.id });
            return foundCardIndex > -1;
          });
          var newCardStatus = newList.status;
          var sequenceCall = updateCardsSequence();
          if (oldCardStatus !== newCardStatus) {
            $scope.cardStatusChange(card, newCardStatus, true)
            .then(function (response) {
              var data = response.data;
              if (newCardStatus == $scope.doneStatus) {
                getCompletionTime(card, data);
              }
              $scope.filter($scope.cardsTypeFilter.value, $scope.cardsWeirdFilter.value, $scope.tags);
              sequenceCall();
            }, function (res) {
              console.error(res[0].errorKey);
              // https://trello.com/c/PFzlAAOs/3330-task-management-needs-review-rule
              // check if new status is "needs review" and all checklist items are complete
              if (newCardStatus === NEEDS_REVIEW_STATUS) {
                list.cards.splice(index, 0, card);
                newList.cards.splice(foundCardIndex, 1);
                getList(oldCardStatus).cards.splice(index, 0, card);
              }
            });
          } else {
            sequenceCall();
          }
        };

        function updateCardsSequence() {
          var request = [];
          _.forEach($scope.lists, function (list) {
            list.cards.forEach(function (card, index) {
              var sequence = index + 10;
              card.sequence = sequence;
              request.push({
                id: card.id,
                sequence: sequence
              });
            });
          });
          return function () {
            return taskManagementService.sequenceUpdate(request);
          };
        }

        function tagsResult(card, tag) {
        // search in name
          if (card.name.match(new RegExp(tag.text, 'i'))) {
            return 1;
          }
        // search in members
          if (tag.type == 'user') {
            var foundMembers = _.filter(card.members, function (member) {
              return member.id == tag.userId;
            }).length;
            if (foundMembers) {
              return 1;
            }
          }
        // search in teams
          if (tag.type == 'team') {
            if (card.team.id == tag.teamId) {
              return 1;
            }
          }

          if (tag.type === 'company') {
            if (card.companyId === tag.companyId) {
              return 1;
            }
          }
          return 0;
        }

        function getAllCards(tags) {
          allCards = defAllCards;
          if (tags && tags.length) {
            if (oldState.tagLength >= tags.length) {
              allCards = defAllCards;
            } else {
              allCards = $scope.lists.reduce(function (iv, item) {
                return iv.concat(item.cards);
              }, []);
            }
          }
          return allCards;
        }

      // RUN
        $scope.lists = [];
        taskManagementService.getAdminsList().then(function (response) {
          var admins = taskManagementService.adminsList;
          admins.map(function (admin) {
            $scope.tagsToFilter.push({
              text: admin.firstName + ' ' + admin.lastName,
              type: 'user',
              userId: admin.id
            });
          });
        });
        taskManagementService.getTeams().then(function () {
          var teams = taskManagementService.teams;
          teams.map(function (team) {
            $scope.tagsToFilter.push({
              text: team.name,
              type: 'team',
              teamId: team.id
            });
          });
        });

        var tasksPromise = taskManagementService.getTasks();

        var storePromise = taskManagementService.getAllStores()
        .then(function (res) {
          $scope.stores = res.data;
        });

        $q.all([tasksPromise, storePromise])
        .then(function (data) {
          _.each($scope.companies, function (company) {
            $scope.tagsToFilter.push({
              text: company.caption,
              type: 'company',
              companyId: company.id
            });
          });
          setCompanyId(data[0].data);
          return data;
        })
        .then(function (data) {
          allCards = updateAllCards(data[0].data);
          return updateAllCards(data[0].data);
        })
        .then(function (data) {
          defAllCards = data;
          $scope.filter($scope.cardsTypeFilter.value, $scope.cardsWeirdFilter.value);
          if (currentStore) {
            $scope.filter($scope.cardsTypeFilter.value, $scope.cardsWeirdFilter.value, [{
              companyId: 147,
              text: currentStore.caption,
              type: currentStore.id
            }]);
            localStorageService.remove('currentStore');
          }
          if ($scope.taskId) {
            var card = _.find(defAllCards, { id: $scope.taskId.id || $scope.taskId }) || taskStoresService.task;
            if (card) {
              card.companyId = _.find($scope.stores, { id: card.store.id }).companyId;
              card.primaryUserId = _.find($scope.companies, { id: card.companyId }).primaryUserId;
              $scope.openCard(card);
            } else {
              taskManagementService.refreshTask($scope.taskId)
                .then(function (response) {
                  var task = response.data;
                  task.companyId = _.find($scope.stores, { id: task.store.id }).companyId;
                  task.primaryUserId = _.find($scope.companies, { id: task.companyId }).primaryUserId;
                  $scope.openCard(task);
                });
            }
          }
        });

        function initScrolls() {
          [].map.call(document.querySelectorAll('.task-list__content'), function (list) {
            Ps.initialize(list);
          });
        }

        function updateScrolls() {
          Ps.update(document.getElementById('tmContainer'));
          [].map.call(document.querySelectorAll('.task-list__content'), function (list) {
            Ps.update(list);
          });
        }

        function setCompanyId(data) {
          _.each(data, function (card) {
            _.each($scope.stores, function (store) {
              if (card.store.id === store.id) {
                card.companyId = store.companyId;
              }
            });
          });
        }

        function updateAllCards(data) {
          return _.map(data, function (card) {
            _.each($scope.companies, function (company) {
              if (card.companyId === company.id) {
                card.companyCaption = company.caption + ' ' + '(' + company.id + ')';
                card.primaryUserId = company.primaryUserId;
              }
            });

            if (card.status == $scope.doneStatus) {
              getCompletionTime(card);
            }
            return card;
          });
        }

        function getCompletionTime(card, data) {
          data = data || card;
          card.completionTime = +moment(_.maxBy(data.activity, function (activity) {
            if (activity.activityType === 'status_changed' && activity.newStatus === 4) {
              return moment(activity.timeString).format('x');
            }
          }).timeString).format('x');
          card.completionTimeReverse = card.completionTime * -1;
        }

        function getOverdueTasks() {
          overdueTasksService.getOverdueTasks()
          .then(function (data) {
            $scope.overdueTasks = data.data;
          });
        }

        function getDoneItemsLength() {
          if ($scope.limitForDoneList > $scope.doneItemsLength) {
          // $scope.doneItemsCurrentLength = $scope.doneItemsLength;
            $scope.doneItemsCurrentLength = getDoneList().cards.length;
          } else {
            $scope.doneItemsCurrentLength = $scope.limitForDoneList;
          }
        }

        window.setTimeout(function () {
          Ps.initialize(document.getElementById('tmContainer'));
          initScrolls();
          window.addEventListener('resize', updateScrolls);
        }, 1000);

        function getList(status) {
          return _.find($scope.lists, { status: status });
        }

        function getDoneList() {
          return getList($scope.doneStatus);
        }
      }
    };
  }]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/taskManagement/directive.js